
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiagnosticGoogle as ObiDiagnosticGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diagnostic-google.js';
 
 
 

 
 export const ObiDiagnosticGoogle = createComponent({
   react: React,
   tagName: 'obi-diagnostic-google',
   elementClass: ObiDiagnosticGoogleElement,
   events: {
     
   }
  });
 
 